import { useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Loading } from './Loading';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, activeDepartment, userDepartments } = useAuth();
  const location = useLocation();

  if (loading) return <Loading>Cargando sesión...</Loading>;

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Si el user tiene >1 depto y todavia no eligio uno, forzar
  // la pantalla de seleccion. No redirige si ya estamos en /departments.
  const depts = userDepartments();
  if (depts.length > 1 && !activeDepartment && location.pathname !== '/departments') {
    return <Navigate to="/departments" replace />;
  }

  return <>{children}</>;
}
